import React, { ReactElement } from 'react'
import { CartDrawerWrapper } from '@mindfulchefuk/features/Cart/components/CartDrawer/CartDrawerWrapper'

export type TOnboardingCartDrawer = {
  isOpen: boolean
  onClose: () => void
}

export const OnboardingCartDrawer = ({
  isOpen,
  onClose,
}: TOnboardingCartDrawer): ReactElement => {
  return <CartDrawerWrapper isOpen={isOpen} onClose={onClose} />
}
